import { render } from "./Index.vue?vue&type=template&id=7af7588d&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=7af7588d&scoped=true&lang=css"
import "./Index.vue?vue&type=style&index=1&id=7af7588d&lang=css"

import exportComponent from "/codebuild/output/src3012/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7af7588d"]])

export default __exports__